var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-module"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.config.map.link,"allowfullscreen":"","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }